__turbopack_context__.v({
  "className": "magra_ee4972db-module__dq7hfG__className",
});
